const UserFactory = function UserFactory($http) {
  'ngInject';

  const getUsers = ({ limit = 100, skip = 0, searchQuery } = {}) =>
    $http
      .get('/admin/user', {
        params: { $limit: limit, $skip: skip, q: searchQuery },
      })
      .then(response => response.data);
  const getUser = id => $http.get(`/admin/user/${id}`).then(response => response.data);

  const assignPlan = ({ user, plan, days }) =>
    $http
      .post('/admin/user/plan', { user: user._id, plan: plan._id, days })
      .then(response => response.data);

  const getHistory = user =>
    $http.get(`/admin/user/${user._id}/history`).then(response => response.data);
  function update(id, body) {
    $http.put(`/admin/user/${id}`, body);
  }
  return {
    update,
    getUsers,
    getUser,
    assignPlan,
    getHistory,
  };
};

export default UserFactory;



// WEBPACK FOOTER //
// ./client/app/common/user/user.factory.js